import React, {memo} from 'react';
import {LocationPoint, LocationSuperiorsList} from '@/common/interfaces/location';
import {useLocalizer} from '@/common/services/localizer';
import {LocationType} from '@/common/constants/locationType';
import {LocationLink} from '@/app/components/common/LocationLink';
import {TextLink} from '@/common/components/TextLink';
import styles from './LocationBreadcrumbs.css';

interface LocationBreadcrumbsProps {
	location: LocationPoint;
	superiorLocations: LocationSuperiorsList;
}

export const LocationBreadcrumbs = memo((props: LocationBreadcrumbsProps) => {
	const {location, superiorLocations} = props;
	const {country, region, district, subDistrict} = superiorLocations;

	const t = useLocalizer();

	const locations = [
		country && {...country, type: LocationType.Country},
		region && {...region, type: LocationType.Region},
		district && {...district, type: LocationType.District},
		subDistrict && {...subDistrict, type: LocationType.SubDistrict},
		location,
	].filter(Boolean);

	return (
		<div className={styles.root}>
			<div className={styles.main}>
				{t('weather')} {location.titleLc}{' '}
				<ol className={styles.list} itemScope itemType='https://schema.org/BreadcrumbList'>
					{locations.map((item, index) => (
						<li
							key={item!.id}
							className={styles.item}
							itemProp='itemListElement'
							itemScope
							itemType='https://schema.org/ListItem'>
							<LocationLink component={TextLink} location={item!} itemProp='item'>
								<span itemProp='name'>{item!.title}</span>
							</LocationLink>
							<meta itemProp='position' content={(index + 1).toString()} />
						</li>
					))}
				</ol>
			</div>
		</div>
	);
});

LocationBreadcrumbs.displayName = 'LocationBreadcrumbs';
